import React, { FC } from 'react';
import Ballot from '../Ballot/Ballot';
import './styles.css';
import Card from "../../../assets/card.png"

interface GameResult {
  colorCode: string;
  number: string;
}

interface Game {
  code: string;
  fullDate: string;
  result: GameResult[];
}

interface PastResultCardProps {
  game: Game | null;
}

const PastResultCard: FC<PastResultCardProps> = ({ game }) => {
  const gameDate = (date: string | undefined) => {
    if (!date) return '';
    const dateObj = new Date(date);
    return `${dateObj.toLocaleDateString('en-GB')} : ${dateObj.toLocaleTimeString('en-GB')}`;
  };

  const gameTotal = (result: GameResult[] | undefined) => {
    if (!result) return 0;
    return result.reduce((acc, item) => acc + parseInt(item.number), 0);
  };

  const getColorTimes = () => {
    const colorTimes: { [key: string]: number } = {};
    game?.result.forEach((item) => {
      if (!colorTimes[item.colorCode]) {
        colorTimes[item.colorCode] = 1;
      } else {
        colorTimes[item.colorCode] += 1;
      }
    });
    return colorTimes;
  };

  return (
    <div className="result-container d-flex justify-content-center">
      <div className="game-number">
        <h2 className="fw-semibold">{game?.code.split('-')[1]}</h2>
      </div>
      <div className="game-date">
        <h3 className="fw-semibold">{gameDate(game?.fullDate)}</h3>
      </div>
      <img className="img-bg" src={Card} alt="Background" />
      <div className="content d-flex align-items-center">
        {game?.result.map((result, index) => (
          <Ballot
            key={index}
            style={{ height: '8rem', width: '8rem' }}
            color={result.colorCode}
            className="my-auto"
          >
            {result.number}
          </Ballot>
        ))}
      </div>
      <div className="game-stats d-flex text-nowrap">
        <h3 className="fw-semibold my-auto">
          TOTAL LINEA: {gameTotal(game?.result)}
        </h3>
        <div
          className="circle-indicator mx-1 my-auto"
          style={{
            backgroundColor: gameTotal(game?.result) % 2 === 0 ? 'green' : 'red',
          }}
        ></div>
        <h3 className="my-auto ms-1">
          | {gameTotal(game?.result) % 2 === 0 ? 'PAR' : 'IMPAR'}
        </h3>
        <div
          className="circle-indicator mx-1 my-auto"
          style={{
            backgroundColor: gameTotal(game?.result) > 75.5 ? 'green' : 'red',
          }}
        ></div>
        <h3 className="my-auto">
          | {gameTotal(game?.result) > 75.5 ? '+' : '-'} 75.5
        </h3>
        <h3 className="my-auto">| Colores</h3>
        {Object.entries(getColorTimes()).map(([color, count]) => (
          <div
            key={color}
            className="circle-indicator mx-1 my-auto text-dark fw-bold fst-italic d-flex"
            style={{
              height: '2.8rem',
              width: '2.8rem',
              fontSize: '1.8rem',
              backgroundColor: color,
              boxShadow: '0 6px 22px rgba(0, 0, 0, 0.5)',
            }}
          >
            <p className="my-auto mx-auto h2">{count}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PastResultCard;
